import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useWizard } from './context'
import { useAppContext } from '@/context/app'
import { Spinner } from '@/components/spinner'
import { Roles } from '@/services/repository/users'
import { useModal } from '@/components/modal/Modal'
import { SuperAdminInsertMachineTypePopup } from '@/pages/for/superadmin/machinetype/MachineType'
import { SuperAdminInsertUserGroupPopup } from '@/pages/for/superadmin/usergroups/groups'

export interface SimpleUserGroup {
  id: string
  name: string
}

export const CreateMachineWizardStep1 = () => {
  const { services, session, translates } = useAppContext()
  const { openModal } = useModal()
  const { wizardData, updateWizardData, nextStep } = useWizard()
  const [usergroups, setUsergroups] = useState<SimpleUserGroup[]>()
  const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>(wizardData.userGroup)

  function refresh() {
    services.session.fetchWithToken(`/api/communal/usergroups/my`).then((response) => {
      return response.json()
    }).then((data) => {
      setUsergroups(data)
    })
  }

  useEffect(refresh, [])

  const isManager = useMemo(
    () => session ? [Roles.SuperAdmin, Roles.CompanyAdmin, Roles.CompanyManager].includes(session.user.role as any) : false,
    [session]
  );

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <>
    <div>
      <h3>{translates.for('popup.create_machine_wizard.select_usergroup_title')}</h3>
      {isManager ? <div className='left-btns'>
        <button className="popup-add" onClick={() => openModal((props) => SuperAdminInsertUserGroupPopup({
          ...props, services, session, onInsert: (group: SimpleUserGroup) => {
            // refresh()
            setSelectedGroupId(group.id)
            updateWizardData({
              userGroup: group.id
            })
            nextStep()
          }
        }))}>
          {translates?.for('popup.create_machine_wizard.add_usergroup')}
        </button>
      </div> : null}

      <ul className="usergroup-list">
        {usergroups ? usergroups?.map((group) => (
          <li
            key={group.id}
            className={selectedGroupId === group.id ? 'selected' : ''}
            onClick={() => {
              setSelectedGroupId(group.id)
              updateWizardData({
                userGroup: group.id
              })
              nextStep()
            }}
          >
            {group.name}
          </li>
        )) : <Spinner />}
      </ul>
      {selectedGroupId ? <div className='right-btns'>
        <button className='btn btn-next' onClick={nextStep}>{translates.for('popup.create_machine_wizard.next')}</button>
      </div> : null}
    </div>
  </>
}

